import axiosRequest from '@/utils/request'

// 更新支付密码发送短信
export const updateOtp = (data) => {
  return axiosRequest({
    url: '/me/update-otp',
    data,
    method: 'post'
  })
}
